// extracted by mini-css-extract-plugin
export default {"tableTitle":"Tables_tableTitle__+8dDE","blackColor":"Tables_blackColor__4Bd9s"};